import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { ForgotPasswordService } from '../../_services/forgot-password.service';

@Component({
	selector: 'app-email',
	templateUrl: './email.component.html',
	styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {

	changePswdForm : FormGroup;
	private url = environment.url;

	constructor(private http : HttpClient, private router : Router, private forgotPasswordService: ForgotPasswordService) { }

	ngOnInit() {
		this.changePswdForm = new FormGroup ({
			"username" : new FormControl(null, Validators.required)
		});
	};

	submit(){
		console.log(this.changePswdForm.get("username").value);
		this.forgotPasswordService.forgotPasswordEmail(this.changePswdForm.value)
		.subscribe(resp =>{
			console.log(resp);
			if (resp['status'] === true) {
				// this.router.navigate(['/forgot-password/email-confirmation']);
				swal('Success', resp['message'], 'success').then(() => {
				     this.router.navigate(['/login']);
				});
			} else {
				swal('Failure', resp['message'], 'error');
			}
		})
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/forgot-password/email/email.component.ts